export default __webpack_public_path__ + "static/media/select-layer-video.e603ef78.gif";